import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from '@elem/ui/ef-picture';
import gtm from '@/utils/gtm';

const Rooftop = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('costsaving');

    const list = [
        {
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749017243876/rooftop_pc1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1749017244298/rooftop_h51.jpg',
            },
        },
        {
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749017243648/rooftop_pc2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1749017244107/rooftop_h52.jpg',
            },
        },
        {
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1749017243237/rooftop_pc3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1749017243449/rooftop_h53.jpg',
            },
        },
    ];

    const handleClick = () => {
        const url = 'https://www.ecoflow.com/us/ocean-pro-home-solar-battery';
        gtm.push({
            event: 'uaEvent',
            event_name: 'jump_button',
            position: t(`rooftop_sub_title`),
            button_name: t(`rooftop_title`) + '_' + t(`common_card_more`),
            url: url,
        });
        window.open(url, '_blank');
    };

    return (
        <div className={styles['rooftop']} id="rooftop">
            <div className="rooftop-container">
                <div className="text-box">
                    <h2>{t(`rooftop_title`)}</h2>
                    <p className="desc">{t(`rooftop_desc`)}</p>
                </div>

                <div className="content">
                    <div className="left">
                        <Swiper
                            spaceBetween={10}
                            className="rooftop-swiper"
                            pagination={{
                                clickable: true,
                            }}
                            loop={true}
                            modules={[Pagination]}
                            slidesPerView={'auto'}
                        >
                            {list.map((item: any) => (
                                <SwiperSlide className={'rooftop-slide'} key={item.img.pc}>
                                    <EFPicture
                                        className="rooftop-img"
                                        src={item.img.pc}
                                        srcPad={item.img.h5}
                                        srcMobile={item.img.h5}
                                        alt={t('rooftop_title')}
                                    />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <div className="right">
                        <h3 className="title">{t(`rooftop_sub_title`)}</h3>
                        <ul>
                            <li>{t(`rooftop_sub_desc1`)}</li>
                            <li>{t(`rooftop_sub_desc2`)}</li>
                            <li>{t(`rooftop_sub_desc3`)}</li>
                        </ul>
                        <button className="rooftop-link" onClick={handleClick}>
                            {t(`common_card_more`)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rooftop;
